// extracted by mini-css-extract-plugin
export default {"card":"SkillCard_card__XY5WR"};